<template>
  <v-col class="full-height pr-12">
    <v-row class="d-block">
      <DragAndDrop :bucket="bucket" />
    </v-row>
    <v-row class="hide-scrollbar custom-row">
      <Treeview :bucket="bucket" :kind="'Exchange'" />
      <v-overlay :absolute="true" :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-row>
  </v-col>
</template>
<script>
import Treeview from "@/components/layout/Treeview";
import DragAndDrop from "@/components/layout/DragAndDrop";
import awsmobile from "@/api/aws-exports";
import { mapState } from "vuex";

export default {
  name: "provider",
  data: () => ({
    loading: false,
    bucket: awsmobile["exchange_bucket"],
  }),
  components: {
    Treeview,
    DragAndDrop,
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },
  async created() {
    this.loading = true;
    await this.$store.commit("resetPath");
    await this.$store.dispatch("setTree", {
      bucket: this.bucket,
      father: "",
      parent: "",
    });
    this.loading = false;
  },
};
</script>
<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding-bottom: 10em;
  display: block;
}
.custom-row {
  overflow-y: scroll;
  height: calc(100% - 15em);
}
</style>